import { IGem } from '../redux/gem/gemSlice';
import { GemCertificate } from './enums/gem-certification.enum';
import { GemClarity } from './enums/gem-clarity.enum';
import { GemColor } from './enums/gem-color.enum';
import { GemCut } from './enums/gem-cut.enum';
import { GemOrigin } from './enums/gem-origin.enum';
import { GemShape } from './enums/gem-shape.enum';
import { GemSpecies } from './enums/gem-species.enum';
import { GemTreatment } from './enums/gem-treatment.enum';

export interface IGemTableColumn {
  gemId: string;
  systemId: string;
  uginId: string | null;
  is_scanned: boolean;
  appearanceImage: string;
  favouriteId?: string;
  species: GemSpecies;
  weight: number;
  color: GemColor;
  dimensions?: string;
  length: number;
  depth: number;
  width: number;
  cut: GemCut;
  shape: GemShape;
  clarity: GemClarity;
  treatment: GemTreatment;
  origin: GemOrigin;
  certificate: GemCertificate;
}

export const getGemColumnValue = (gem: IGemTableColumn, key: string) => gem[key as keyof IGemTableColumn];

export const capitalizeFirstLetter = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1);
